export enum Roles {
  Admin = "Admin",
  Distributor = "Distributor",
  Manufacturer = "Manufacturer",
  HospitalStaff = "HospitalStaff",
}
